/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-07-27 17:36:50
 * @LastEditTime: 2022-07-25 15:25:51
 * @FilePath: /teacher-h5/src/service/index.js
 */
import login from './login'
import student from './students'
import studentsDetails from './studentsDetails'
import common from './common'
import topic from './topic'
import groupDetails from './groupDetails'
import courseAndGroup from './courseAndGroup'
import video from './video'
import groupManage from './groupManage'
import correction from './correction'
import supervision from './supervision'
import learningSituation from './learningSituation'
import studentRight from './studentRight'
import coin from './coin'
import giveInstruction from './giveInstruction'

export default {
  login,
  student,
  studentsDetails,
  common,
  groupDetails,
  topic,
  courseAndGroup,
  video,
  groupManage,
  correction,
  supervision,
  learningSituation,
  studentRight,
  coin,
  giveInstruction
}